export default __webpack_public_path__ + "static/media/hero.5b68c11e.svg";